/**
 * 模板配置文件 base类
 * @type {[type]}
 */
// var path = require('path');
import Vue from "vue";
import VueRouter from "vue-router";
// import md5 from "js-md5";
//重写路由replace和push方法，解决element ui导航引起的问题
const originalPush = VueRouter.prototype.push,
			originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err)
}

// const appConfig = Vue.appConfig;
const appConfig = {
	mobileMaxWidth: 500,
	
	/**
	 * 返回只允许访问的客户端：false：根据标准逻辑判断，pc：只允许访问pc端，mobile：值允许访问移动端
	 */
	 onlyClient: `function() {
		if(Vue.appCommonH.isWeixin().isWeixin) {
			return 'mobile';
		} else {
			return false;
		}
	}`,
}
const baseTpl = function (params) {}

/**
 * 设置移动端或者pc端页面顶级类
 */
baseTpl.prototype.setClientClass = function(isMobile) {
	if(isMobile) {
		if($("body").hasClass("site_pc_common")) {
			$("body").removeClass("site_pc_common");
		}

		if(!$("body").hasClass("site_mobile_common")) {
			$("body").addClass("site_mobile_common");
		}
	} else {
		if($("body").hasClass("site_mobile_common")) {
			$("body").removeClass("site_mobile_common");
		}
		
		if(!$("body").hasClass("site_pc_common")) {
			$("body").addClass("site_pc_common");
		}
	}
}

/**
 * 根据配置，判断如果是手机环境，并且是pc页面，跳转对应手机页面
 * 手机端和窗口宽度小于指定宽度，则判断为手机端
 * @return {[type]} [description]
 */
baseTpl.prototype.pcToMobile = function(to, next) {
	var nowPage = to.matched && to.matched.length && to.matched[0];
	if(!nowPage) return false;

	var eventIsPhone = window.innerWidth <= appConfig.mobileMaxWidth,
		nowPath = nowPage.path,
		pageIsPhone = !!to.meta.isMobile,
		pcMobileChange = appConfig.pcMobileChange

	//如果设置仅允许访问的客户端类型
	if(appConfig.onlyClient()) {
		let onlyIsPhone = appConfig.onlyClient() == 'mobile';
		
		eventIsPhone = onlyIsPhone;
	}

	if(eventIsPhone !== pageIsPhone) {
		var nowKey = pageIsPhone ? "mobilePath" : "pcPath",
			jumpKey = pageIsPhone ? "pcPath" : "mobilePath",
			isJumped = false;

		pcMobileChange.forEach(function(oneChange) {
			if(oneChange[nowKey] == nowPath) {
				switch(oneChange.type) {
					case 1:
						window.location.href.replace({path: oneChange[jumpKey], query: to.query});
            next && next()
						break;
					case 2:
						oneChange.changeFunc(window.location.href, oneChange[jumpKey], to, next);
						break;
				}

				isJumped = true;
			}
		});
	}

	return isJumped;
}

/**
 * 设置移动端rem
 */
baseTpl.prototype.setMobileRem = function(to) {
	var nowPage = to.matched && to.matched.length && to.matched[0];
	if(!nowPage) return false;

	window.removeEventListener('resize', this.changSize);
	this.setClientClass(!!to.meta.isMobile);

	if(to.meta.isMobile) {
		this.changSize(to);
		window.addEventListener('resize', this.changSize, false);
	} else {
		document.documentElement.style.fontSize = '';
	}
}


/**
 * 监听页面变动更改rem方法
 */
baseTpl.prototype.changSize = function(to) {
	var clientWidth = document.documentElement.clientWidth;
	clientWidth = clientWidth <= appConfig.mobileMaxWidth ? clientWidth : 500;
	clientWidth = clientWidth >= 200 ? clientWidth : 200;
	document.documentElement.style.fontSize = 100 * clientWidth / 375 + 'px';
	
	if(clientWidth >= appConfig.mobileMaxWidth) {
		document.body.style.width = clientWidth+'px';
	}
}


export default baseTpl;
